import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogActions,
  FormControl,
  Typography,
  Button,
  TextField,
  InputAdornment,
} from "@mui/material";
import { useAuthContext } from "src/auth/hooks/use-auth-context";
import { PATH_AFTER_LOGIN } from "../../config-global";
import { PATH_AUTH } from "../../routes/paths";
import { routePrefix } from 'src/utils/methods/StandardMethods';


const TwoFactorAuth = ({ open, onClose }: any) => {
  const [code, setCode] = useState("");
  const { user, logout,verifyMFA } = useAuthContext();

  const navigate = useNavigate();

  const handleQR = async (e: any) => {
    e.preventDefault();
    if (code) {
        verifyMFA(user?.id, code, user?.ismfaEnabled, user?.twoFactorSecret, user?.rememberMe).then((isSuccessful:any) => {
          console.log("isSuccessful",isSuccessful);
          if(isSuccessful?.isValid){
            navigate(PATH_AFTER_LOGIN(routePrefix(isSuccessful?.user)));
          }
          else {
            alert("Invalid MFA Token");
          }
        }).catch((err:any) => {
          console.log(err);
        }
        );
    }
  }

  const handleClose = () => {
    onClose();
    logout();
    navigate(PATH_AUTH.login, { replace: true });
  };

  const handleCantScanQRCode = () => {
    console.log("Can't scan QR code");
  };

  return (
    console.log("TwoFactorAuth", open, user),
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <Typography variant="h6" sx={{ mt: 2 }}>
            Scan the QR code below using any authenticator app of your choice
            such as{" "}
            <a
              href="https://authy.com/"
              style={{ textDecoration: "none", color: "#551A8B" }}
            >
              Authy
            </a>
            ,{" "}
            <a
              href="https://support.google.com/accounts/answer/1066447?co=GENIE.Platform%3DAndroid&hl=en"
              style={{ textDecoration: "none", color: "#551A8B" }}
            >
              Google Authenticator
            </a>
            ,{" "}
            <a
              href="https://www.lastpass.com/solutions/authentication"
              style={{ textDecoration: "none", color: "#551A8B" }}
            >
              LastPass Authenticator
            </a>
          </Typography>
          <img
            style={{ width: "auto", height: "100%", margin: "0 auto", display: "block" }}
            src={user?.mfaQrCodeUri}
            alt="QR Code"
          />
          <Typography variant="body2" >
            <a href="#" style={{ textDecoration: "none", color: "#551A8B" }} onClick={handleCantScanQRCode}>
              Can't scan the QR code?
            </a>
          </Typography>
          <Typography variant="h6" style={{ marginTop: "8px" }}>
            After scanning the QR code, you will be given a 6-digit verification
            code. Please enter it below.
          </Typography>
        </div>
        <FormControl fullWidth sx={{ mt: 3 }}>
          <TextField
            type="text"
            variant="outlined"
            label="Enter 6-digit code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{ background: "#76899A" }}
                    onClick={handleQR}
                  >
                    Verify
                  </Button>
                </InputAdornment>
              ),
            }}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TwoFactorAuth;

